import React from "react";

export default function Header({ title }: { readonly title: string }) {
  return (
    <div className="bg-orange-50 flex text-center justify-center">
      <h1 className="text-3xl p-4 text-wrap text-white">{title}</h1>
    </div>
  );
}
